const acknowledge = () => (state) => {
  return Object.assign({}, state, { succeeded: false, error: null })
}

export default acknowledge
